// extracted by mini-css-extract-plugin
export default {"box":"_solarsmart_box__WDJYy","freePlantRow":"_solarsmart_freePlantRow__vvPs8"};